import { Component } from '@angular/core';
import { Validators } from '@angular/forms';
import { SelectItem } from 'primeng/primeng';
import { Instrutor } from "../../entity/instrutor.model";
import { BaseCrudComponent } from 'app/base';
import { AnexoInstrutor } from '../../entity/curriculo-instrutor.models';
import { ValidCpfORCnpj } from '../../util/custom.validators';
import { Situacoes } from '../../entity/enumeraveis';

@Component({
    selector: 'instrutor-crud',
    templateUrl: 'instrutor-crud.component.html'
})

export class CrudInstrutorComponent extends BaseCrudComponent {
    controllerName = 'instrutor';
    instrutor: Instrutor = new Instrutor();
    listaFormacaoAcademico: SelectItem[] = [];
    listaFormacaoAcademicoCompleto: SelectItem[] = [];
    listaCursos: SelectItem[] = [];
    listaCursosCompleto: SelectItem[] = [];
    uploadedFiles: any[] = [];
    listaFormacaoInstrutor: any[] = [];
    countListaArquivos: any[] = [];
    anexo_instrutor: AnexoInstrutor;
    validateForm: any = false;
    isValid: boolean = false;
    stepObject: any;
    isCPF: boolean = true;
    modalTermoAceiteLGPD: boolean = false;

    setStepObject(obj: any) {
        this.stepObject = obj;
    }

    init() {
        this.cadastro = this.formBuilder.group({
            instrutor: this.formBuilder.group({
                nome: [null, [Validators.required, Validators.maxLength(100)]],
                cpf: [null, [Validators.required, ValidCpfORCnpj, Validators.maxLength(20)]],
                passaporte: [null, [Validators.maxLength(100)]],
                id: [null],
                registro_profissional: [null],
                tipo_documento: [1, [Validators.required]],
                flg_termoLGPD: [null]
            }),
            formacao_instrutor: this.formBuilder.group({
                id_area: [null, [Validators.required]],
                id_formacao_academica: [null, [Validators.required]],
                curso: [null, [Validators.required, Validators.maxLength(255)]],
                id_instrutor: [null],
            }),
            anexo_instrutor: this.formBuilder.group({
                id_anexo: [null, [Validators.required]],
                id_instrutor: [null, [Validators.required]],
                id: [null]

            })
        });
        this.service.ListarTodos('cursoAcademico').subscribe(data => {
            this.listaCursosCompleto = data;
            this.listaCursos = data.filter(a => a.id_situacao == Situacoes.Ativo);
        })
        this.service.ListarTodos('formacao-academica').subscribe(data => {
            this.listaFormacaoAcademicoCompleto = data;
            this.listaFormacaoAcademico = data.filter(a => a.id_situacao == Situacoes.Ativo);
        });

        this.cadastro.get('instrutor.tipo_documento').valueChanges.subscribe(
            data => {
                if (data == 1) {
                    this.cadastro.get('instrutor.cpf').setValidators([Validators.required, ValidCpfORCnpj, Validators.maxLength(20)]);
                    this.cadastro.get('instrutor.passaporte').setValidators(null);
                    this.isCPF = true;
                    this.cadastro.get('instrutor.passaporte').reset();
                }
                else {
                    this.cadastro.get('instrutor.passaporte').setValidators([Validators.required, Validators.maxLength(100)]);
                    this.cadastro.get('instrutor.cpf').setValidators(null);
                    this.cadastro.get('instrutor.cpf').reset();
                    this.isCPF = false;
                }
            }
        );
    }

    afterLoad() {
        console.log(this.obj);
        this.cadastro.get('instrutor').patchValue(this.obj);
        if (this.obj.tipo_documento == 1)
            this.cadastro.get('instrutor.cpf').setValue(this.obj.cpf_passaporte);
        else
            this.cadastro.get('instrutor.passaporte').setValue(this.obj.cpf_passaporte);

        this.cadastro.get('formacao_instrutor').patchValue(this.obj.formacao_academica_instrutor);
        this.listaFormacaoInstrutor = this.obj.formacao_academica_instrutor;
        if (this.obj.anexo_instrutor != null) {
            this.obj.anexo_instrutor.forEach(x => {
                x.show = true;
                this.uploadedFiles.push(x);
            });
        }
    }
    finalizar(event: any) {
        this.instrutor.anexo_instrutor = [];
        if (this.cadastro.get('instrutor.tipo_documento').value == 1)
            this.instrutor.cpf_passaporte = this.limpaCaracterEspecial(this.cadastro.value.instrutor.cpf);
        else
            this.instrutor.cpf_passaporte = this.limpaCaracterEspecial(this.cadastro.value.instrutor.passaporte);
        this.instrutor.registro_profissional = this.cadastro.value.instrutor.registro_profissional;
        this.instrutor.nome = this.cadastro.get('instrutor.nome').value;
        if (this.cadastro.value.instrutor.id == null) {
            this.instrutor.id = 0;
        } else {
            this.instrutor.id = this.cadastro.value.instrutor.id;
        }
        this.instrutor.tipo_documento = this.cadastro.get('instrutor.tipo_documento').value;
        this.instrutor.flg_termoLGPD = this.cadastro.get('instrutor.flg_termoLGPD').value;

        this.instrutor.anexo_instrutor = [];
        this.uploadedFiles.forEach(item => {
            this.instrutor.anexo_instrutor.push(item);
        });
        this.instrutor.formacao_academica_instrutor = this.listaFormacaoInstrutor.map(item => {
            item.id_instrutor = this.instrutor.id;
            return item;
        });
        
        if (!this.instrutor.flg_termoLGPD){
            this.modalTermoAceiteLGPD = true;            
        }
        else{
            this.doFinalAction(this.instrutor);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/instrutor/crud/instrutor-crud.component.ts